module.exports = __webpack_public_path__ + "static/media/logowhite.ca3cb548.png";